<template>
  <a-drawer
    width="45%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
      <a-tag v-if="form.status === 0" color="orange" style="margin-left: 8px;">待审核</a-tag>
      <a-tag v-else-if="form.status === 1" color="green" style="margin-left: 8px;">已通过</a-tag>
      <a-tag v-else-if="form.status === -1" color="red" style="margin-left: 8px;">已驳回</a-tag>
    </a-divider>

    <a-spin :spinning="loading">
      <!-- 医院基本信息 -->
      <a-card title="医院基本信息" size="small" :bordered="false" class="info-card">
        <a-descriptions :column="2" size="small" bordered>
          <a-descriptions-item label="医院名称" :span="2">
            {{ form.hospitalName || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="医院标志" :span="1">
            <img
              v-viewer
              v-if="form.logo"
              :src="processImageUrl(form.logo)"
              style="height: 80px; width: 80px; cursor: pointer; border-radius: 4px;"
            />
            <span v-else style="color: #999;">暂无</span>
          </a-descriptions-item>
          <a-descriptions-item label="医院地址" :span="1">
            {{ form.address || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="医院等级">
            <dict-tag :options="dict.type['hospital_level']" :value="form.level"/>
          </a-descriptions-item>
          <a-descriptions-item label="医院类型">
            <dict-tag :options="dict.type['hospital_type']" :value="form.type"/>
          </a-descriptions-item>
          <a-descriptions-item label="医院性质">
            <dict-tag :options="dict.type['hospital_nature']" :value="form.nature"/>
          </a-descriptions-item>
          <a-descriptions-item label="所在地区">
            {{ form.provinceName }}{{ form.cityName }}{{ form.areaName }}
          </a-descriptions-item>
          <a-descriptions-item label="获得荣誉" :span="2">
            {{ form.honor || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="荣誉凭证" :span="2">
            <a v-if="form.certificate" @click="viewCertificates">
              <a-icon type="picture" /> 查看荣誉凭证
            </a>
            <span v-else style="color: #999;">暂无</span>
          </a-descriptions-item>
          <a-descriptions-item label="身份资格证明" :span="2">
            <a v-if="form.qualificationCertificate" @click="viewQualificationCertificates">
              <a-icon type="picture" /> 查看身份资格证明
            </a>
            <span v-else style="color: #999;">暂无</span>
          </a-descriptions-item>
          <a-descriptions-item label="医院简介" :span="2">
            <div style="max-height: 100px; overflow-y: auto;">{{ form.content || '-' }}</div>
          </a-descriptions-item>
        </a-descriptions>
      </a-card>

      <!-- 联系人信息 -->
      <a-card title="联系人信息" size="small" :bordered="false" class="info-card" style="margin-top: 16px;">
        <a-descriptions :column="3" size="small" bordered>
          <a-descriptions-item label="联系人姓名">
            {{ form.name || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="职位">
            {{ form.position || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话">
            {{ form.mobile || '-' }}
          </a-descriptions-item>
        </a-descriptions>
      </a-card>

      <!-- 审核操作 -->
      <a-card
        title="审核操作"
        size="small"
        :bordered="false"
        class="info-card"
        style="margin-top: 16px;"
        v-if="isInfo == 1">
        <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="审核状态" prop="status">
                <a-radio-group v-model="form.status" @change="handleStatusChange">
                  <a-radio :value="1">
                    <a-tag color="green">通过</a-tag>
                  </a-radio>
                  <a-radio :value="-1">
                    <a-tag color="red">驳回</a-tag>
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.status === -1">
              <a-form-model-item label="驳回原因" prop="rejectReason">
                <a-textarea
                  v-model="form.rejectReason"
                  placeholder="请输入驳回原因，必填"
                  :rows="2"
                  :maxlength="200"
                  showCount
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>

      <!-- 驳回信息（详情模式显示） -->
      <a-card
        title="审核结果"
        size="small"
        :bordered="false"
        class="info-card"
        style="margin-top: 16px;"
        v-if="isInfo == 2 && form.status !== 0">
        <a-descriptions :column="1" size="small" bordered>
          <a-descriptions-item label="审核状态">
            <a-tag v-if="form.status === 1" color="green">已通过</a-tag>
            <a-tag v-else-if="form.status === -1" color="red">已驳回</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="驳回原因" v-if="form.status === -1">
            <span style="color: #f5222d;">{{ form.rejectReason || '-' }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-card>
    </a-spin>

    <!-- 图片预览modal -->
    <a-modal
      v-model="certificatePreviewVisible"
      :title="previewTitle"
      :footer="null"
      :width="800"
      centered
    >
      <div style="text-align: center;">
        <img
          :src="certificateImages[currentPreviewIndex]"
          style="max-width: 100%; max-height: 600px;"
          alt="预览图片"
        />
        <div v-if="certificateImages.length > 1" style="margin-top: 16px;">
          <a-button @click="prevImage" :disabled="currentPreviewIndex === 0">
            上一张
          </a-button>
          <span style="margin: 0 16px;">
            {{ currentPreviewIndex + 1 }} / {{ certificateImages.length }}
          </span>
          <a-button @click="nextImage" :disabled="currentPreviewIndex === certificateImages.length - 1">
            下一张
          </a-button>
        </div>
      </div>
    </a-modal>

    <div class="bottom-control">
      <a-space>
        <template v-if="isInfo == 1">
          <a-button type="primary" :loading="submitLoading" @click="submitForm" :disabled="form.status === 0">
            <a-icon type="check" />提交审核
          </a-button>
          <a-button @click="cancel">
            取消
          </a-button>
        </template>
        <a-button v-else @click="cancel">
          关闭
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getAuth, checkHospital } from '@/api/hospital/auth'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  dicts: ['hospital_level', 'hospital_type', 'hospital_nature'],
  data () {
    return {
      submitLoading: false,
      loading: false,
      formTitle: '',
      isInfo: 1,
      form: {
        id: null,
        userId: null,
        hospitalName: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        areaId: null,
        areaName: null,
        address: null,
        lon: null,
        lat: null,
        logo: null,
        level: null,
        type: null,
        nature: null,
        honor: null,
        content: null,
        name: null,
        position: null,
        mobile: null,
        certificate: null,
        qualificationCertificate: null,
        status: 0,
        rejectReason: null
      },
      formType: 1,
      open: false,
      certificatePreviewVisible: false,
      certificateImages: [],
      currentPreviewIndex: 0,
      previewTitle: '荣誉凭证预览',
      rules: {
        status: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
        rejectReason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {},
  methods: {
    processImageUrl,
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.isInfo = 1
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        hospitalName: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        areaId: null,
        areaName: null,
        address: null,
        lon: null,
        lat: null,
        logo: null,
        level: null,
        levelName: null,
        type: null,
        typeName: null,
        nature: null,
        honor: null,
        content: null,
        name: null,
        position: null,
        mobile: null,
        certificate: null,
        qualificationCertificate: null,
        status: 0,
        rejectReason: null
      }
      this.certificateImages = []
      this.currentPreviewIndex = 0
      this.previewTitle = '荣誉凭证预览'
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleInfo (row) {
      this.open = true
      this.reset()
      this.formTitle = '医院认证详情'
      this.isInfo = 2
      this.loading = true
      getAuth({ id: row.id }).then(response => {
        this.form = response.data
      }).finally(() => {
        this.loading = false
      })
    },
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      this.isInfo = 1
      const id = row ? row.id : ids
      this.formTitle = '医院认证审核'
      this.loading = true
      getAuth({ id: id }).then(response => {
        this.form = response.data
        this.form.status = 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleStatusChange () {
      if (this.form.status !== -1) {
        this.form.rejectReason = null
      }
    },
    submitForm () {
      if (this.form.status === 0) {
        this.$message.warning('请选择审核状态')
        return
      }
      if (this.form.status === -1 && !this.form.rejectReason) {
        this.$message.warning('请输入驳回原因')
        return
      }
      this.$confirm({
        title: '确认审核',
        content: this.form.status === 1 ? '确认通过该医院的认证申请？' : '确认驳回该医院的认证申请？',
        onOk: () => {
          this.submitLoading = true
          checkHospital(this.form).then(response => {
            this.$message.success('审核成功')
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    // 查看荣誉凭证
    viewCertificates() {
      if (this.form.certificate) {
        this.certificateImages = this.form.certificate.split(',').map(url => processImageUrl(url))
        this.currentPreviewIndex = 0
        this.previewTitle = '荣誉凭证预览'
        this.certificatePreviewVisible = true
      } else {
        this.$message.warning('暂无荣誉凭证')
      }
    },
    // 查看身份资格证明
    viewQualificationCertificates() {
      if (this.form.qualificationCertificate) {
        this.certificateImages = this.form.qualificationCertificate.split(',').map(url => processImageUrl(url))
        this.currentPreviewIndex = 0
        this.previewTitle = '身份资格证明预览'
        this.certificatePreviewVisible = true
      } else {
        this.$message.warning('暂无身份资格证明')
      }
    },
    // 上一张图片
    prevImage() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--
      }
    },
    // 下一张图片
    nextImage() {
      if (this.currentPreviewIndex < this.certificateImages.length - 1) {
        this.currentPreviewIndex++
      }
    }
  }
}
</script>

<style scoped>
.info-card {
  background: #fafafa;
}
.info-card >>> .ant-card-head {
  border-bottom: 1px solid #e8e8e8;
  padding: 0 12px;
  min-height: 40px;
}
.info-card >>> .ant-card-head-title {
  padding: 8px 0;
  font-size: 14px;
}
.info-card >>> .ant-card-body {
  padding: 12px;
}
.info-card >>> .ant-descriptions-item-label {
  min-width: 100px;
  white-space: nowrap;
}
.info-card >>> .ant-descriptions-item-content {
  min-width: 150px;
}
.bottom-control {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  padding: 12px 24px;
  text-align: right;
  z-index: 10;
}
</style>
